import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import { t } from 'ember-intl';
import { DOMAIN_NAME } from 'frontend-utils/utils/constants/domain-utils';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';

interface HotelStrategyTablesCellsTdNonComputableSignature {
  Args: {
    cellData: {
      formattedValue: string;
      isNonComputable?: boolean;
    };
  };
}

const HotelStrategyTablesCellsTdNonComputable: TOC<HotelStrategyTablesCellsTdNonComputableSignature> =
  <template>
    <div class="text-200--regular flex items-center justify-center">
      {{#if @cellData.isNonComputable}}
        <a
          data-event-id="hotel-rate-strategy-non-computable-icon-clicked"
          href={{concat
            "https://help."
            DOMAIN_NAME
            "/en/articles/5376608-what-does-this-icon-mean-in-rate-strategy"
          }}
          rel="noopener noreferrer"
          target="_blank"
        >
          <GeneralIconWithTooltip
            @iconName="warning"
            @side="top"
            @size="small"
            @tooltipContent={{t "strategy.warning.cannot_be_calculated"}}
          />
        </a>
      {{else}}
        {{@cellData.formattedValue}}
      {{/if}}
    </div>
  </template>;

export default HotelStrategyTablesCellsTdNonComputable;
